'use strict';

var Cn = require("re-classnames/src/Cn.bs.js");
var ReasonReact = require("reason-react/src/ReasonReact.js");
var ButtonModuleScss = require("./button.module.scss");

var component = ReasonReact.statelessComponent("Button");

function s(prim) {
  return prim;
}

function make(_type, className, children) {
  return /* record */[
          /* debugName */component[/* debugName */0],
          /* reactClassInternal */component[/* reactClassInternal */1],
          /* handedOffState */component[/* handedOffState */2],
          /* willReceiveProps */component[/* willReceiveProps */3],
          /* didMount */component[/* didMount */4],
          /* didUpdate */component[/* didUpdate */5],
          /* willUnmount */component[/* willUnmount */6],
          /* willUpdate */component[/* willUpdate */7],
          /* shouldUpdate */component[/* shouldUpdate */8],
          /* render */(function () {
              var classNames = Cn.make(/* :: */[
                    ButtonModuleScss.root,
                    /* :: */[
                      Cn.ifOpt(className),
                      /* [] */0
                    ]
                  ]);
              return ReasonReact.createDomElement("button", {
                          type: _type,
                          className: classNames
                        }, children);
            }),
          /* initialState */component[/* initialState */10],
          /* retainedProps */component[/* retainedProps */11],
          /* reducer */component[/* reducer */12],
          /* subscriptions */component[/* subscriptions */13],
          /* jsElementWrapped */component[/* jsElementWrapped */14]
        ];
}

exports.component = component;
exports.s = s;
exports.make = make;
/* component Not a pure module */



// WEBPACK FOOTER //
// ./src/components/button.js